import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { PlatformBasicInfo, PlatformConfig } from './types/platform';

const request = createAppRequest();

export async function getPlatformConfig(options?: ApiRequestOptions) {
  return request<PlatformConfig>('/bff/platform-config', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getPlatformBasicInfo(options?: ApiRequestOptions) {
  return request<PlatformBasicInfo>('/bff/platform-basic-info', {
    method: 'GET',
    ...(options || {}),
  });
}
